import {fromJS} from 'immutable';

const defState = fromJS({
    defaultLanguage: 'lv',
    selectedLanguage: 'ru',
    productsPerPage: 6,
    catalogPage: 0,
    redirect: false,
});

export default function reducer(state = defState, action) {
    switch (action.type) {
        case 'CHANGE_CATALOG_PAGE' : {
            const {page} = action.payload;
            return state.set('catalogPage', page);
        }
        case 'REDIRECT' : {
            return state.set('redirect', action.payload.url);
        }
        default:
            return state;
    }
};